import { __rest } from "tslib";
import { createElement, forwardRef, useContext } from 'rax';
import Button from '../button/button';
import Context from './context';
const Reset = forwardRef((props, ref) => {
    const { onClick, toDefault = true, names, children } = props, other = __rest(props, ["onClick", "toDefault", "names", "children"]);
    const { form, size } = useContext(Context);
    const handleClick = (e) => {
        if (form) {
            form.reset(toDefault, names);
        }
        if (onClick) {
            onClick(e);
        }
    };
    return (<Button ref={ref} size={size} {...other} onClick={handleClick}>
      {children}
    </Button>);
});
export default Reset;
